<template>
  <div class="padding">
    <div class="d-flex">
      <FormSelect v-model="reason"
        class="sm form-element"
      
        :options="options"
        label="Reason"
      />
      <FormDatePicker v-model="createdAt"
        class="sm form-element"
      
        id="orderNumber"
        label="Created at"
      />
    </div>
    
      
    <InfiniteScrolling v-if="loading || mutations.length"
      :searchMore="searchMore"
      :showEnd="showEnd"

      ref="infinite-scrolling"
    >
      <ul :class="{'disable-ske': !loading}">
        <MutationEvent v-for="event in computedMutations"
          v-bind="event"
        />
      </ul>
    </InfiniteScrolling>
    <div v-else class="d-flex justify-content-center align-items-center" style="height: 400px">
      <EmptyStatePlaceholder key="empty-staet"
        title="Dit product heeft geen mutatiegebeurtenissen."
      >
        <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z" clip-rule="evenodd"></path></svg>
      </EmptyStatePlaceholder>
    </div>
  </div>
</template>

<script>

import MutationEvent from "./MutationEvent.vue"
import FormInput from "../../Inputs/FormInput.vue"
import InfiniteScrolling from "../../../layout/InfiniteScrolling.vue"
import EmptyStatePlaceholder from "../../../layout/EmptyStatePlaceholder.vue"
import FormSelect from "../../Inputs/FormSelect.vue"
import FormDatePicker from "../../Inputs/FormDatePicker.vue"

const basePlaceholder = {
  "sku": "string",
  "reason": "SOLD_TO_CUSTOMER",
  "newStock": 0,
  "previousStock": 0,
  "diff": 0,
  "createdAt": "2022-03-13T16:31:27.584Z"
}

export default {
  components: {
    FormSelect,
    EmptyStatePlaceholder,
    MutationEvent,
    FormDatePicker,
    FormInput,
    InfiniteScrolling,
  },
  props: {
    productId: String,
  },
  async created() {
    this.mutations = await this.fetch()
    this.showEnd = this.mutations.length >= 10
  },
  data() {
    return {
      showEnd: false,
      
      mutations: [],
      placeholder: [
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
        basePlaceholder,
      ],
      loading: false,
      reason: null,
      createdAt: null,
    }
  },
  methods: {
    async searchMore(page = 1) {
      const list = await this.fetch(page)
      this.mutations.push(...list)

      return list.length === 0
    },
    async fetch(page = 1) {
      this.loading = true
      const mutations = (await this.axios.get(`/api/products/${this.productId}/stock-mutations`, {
        params: {
          reason: this.reason,
          createdAt: this.createdAt,
          // createdAt: this.createdAt ? new Date(this.createdAt).toISOString() : null,
          page,
        }
      })).data.results
      this.loading = false

      return mutations
    },
    async resetAndRefetch() {
      this.$refs["infinite-scrolling"] && this.$refs["infinite-scrolling"].reset()
      this.mutations = []
      this.showEnd = !(await this.searchMore(1))
    },
    dispatchRefetch() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
  
      this.timeout = setTimeout(this.resetAndRefetch, 200)
    },
  },
  computed: {
    options() {
      return [
        {
          str: "All",
          value: null,
        },
        {
          str: "Sold to customer",
          value: "SOLD_TO_CUSTOMER",
        },
        {
          str: "Added stock",
          value: "ADDED_STOCK",
        },
        {
          str: "Modified in backoffice",
          value: "MODIFIED_IN_BACKOFFICE",
        },
        {
          str: "Returned order",
          value: "RETURNED_ORDER",
        },
      ]
    },
    computedMutations() {
      return this.mutations.length ? this.mutations : this.placeholder
    },
  },
  watch: {
    reason() {
      this.dispatchRefetch()
    },
    createdAt() {
      this.dispatchRefetch()
    },
  },
}

</script>

<style scoped src="@/assets/css/form.css"></style>
